import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../../core/services/network-call.service';
import * as forgotPasscodeResendOtp from '../actions/forgot-passcode-resend-otp.actions';
import { catchError, switchMap, concatMap, map } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { of } from 'rxjs';
import { IForgotPasscodeResentOtpRequest, IForgotPasscodeResentOtpResponse } from '../models/forgot-passcode-resend-otp.model';
import { HelpersService } from '../../../core/services/helpers.service';
import notify from 'devextreme/ui/notify';

@Injectable()
export class ForgotPasscodeResendOtpEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService
  ) {}

  forgotPasscodeResendOtp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(forgotPasscodeResendOtp.loadForgotPasscodeResendOtp),
      switchMap(action =>
        this.networkCallService
          .post<IForgotPasscodeResentOtpRequest, IForgotPasscodeResentOtpResponse>('Authentication/forgotPasscodeResendOtp', action.request)
          .pipe(
            map(response => {
              if (response.success) {
                this.helperService.notifySuccess(`Woosh! Your new OTP is on the way!`, 300, 3000);
              }
              return forgotPasscodeResendOtp.loadForgotPasscodeResendOtpSuccess({
                response
              });
            }),
            retryTransientHttpErrors(),
            catchError(error => {
              return of(forgotPasscodeResendOtp.loadForgotPasscodeResendOtpFailure(error));
            })
          )
      )
    )
  );
}
